<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="600px"
        transition="slide-y-transition"
        eager
        persistent
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        {{ title }}
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                {{ description }}
            </v-card-text>
            
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    @click="onAgree"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'SimpleUniversalAgreeDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        }
    },
    data() {
        return {}
    },
    methods: {
        onAgree() {
            this.$emit('on-agree')
        }
    }
}
</script>
